import {
  ICreateLicenseRequestParams,
  ILicenseRequestItemInput,
  ILicenseRequestUpdateParams,
} from "~/entity/Licenses/model/schema";
import { parseNumeric } from "~/shared/lib/parseNumeric";

import { ILicenseRequestPositionForm } from "./types";

export interface ILicenseRequestOwner {
  dealerId?: string;
  organizationId?: string;
}

const mapPositionsToItems = (
  positions: ILicenseRequestPositionForm[],
): ILicenseRequestItemInput[] =>
  positions.reduce<ILicenseRequestItemInput[]>((acc, row) => {
    const instanceId = row.position?.value;
    const quantity = parseNumeric(row.quantity);

    if (!instanceId || quantity === null || quantity <= 0) {
      return acc;
    }

    acc.push({
      instanceId: Number(instanceId),
      quantity,
    });

    return acc;
  }, []);

export const mapFormToCreatePayload = (
  positions: ILicenseRequestPositionForm[],
  owner: ILicenseRequestOwner,
  send?: boolean,
): ICreateLicenseRequestParams => ({
  ...(owner.dealerId ? { dealerId: Number(owner.dealerId) } : {}),
  ...(owner.organizationId ? { organizationId: owner.organizationId } : {}),
  ...(send ? { action: "SEND" as const } : {}),
  items: mapPositionsToItems(positions),
});

export const mapFormToUpdatePayload = (
  positions: ILicenseRequestPositionForm[],
  owner: ILicenseRequestOwner,
  send?: boolean,
): ILicenseRequestUpdateParams => ({
  action: send ? "SEND" : "DRAFT",
  ...(owner.dealerId ? { dealerId: Number(owner.dealerId) } : {}),
  ...(owner.organizationId ? { organizationId: owner.organizationId } : {}),
  items: mapPositionsToItems(positions),
});
